module.exports = __webpack_public_path__ + "img/federated-learning-min.82a08626.jpeg";